import { PaginationBase } from "@/app/api/types";
import { SortingState, Updater } from "@tanstack/table-core";

export const getParamAsInt = (params: URLSearchParams, name: string) => {
  const raw = params.get(name);
  if (!raw) return undefined;
  return parseInt(raw, 10);
};

export function isSortingState(
  sort: Updater<SortingState>
): sort is SortingState {
  return typeof sort !== "function";
}

export const parsePagination = (
  searchParams: URLSearchParams
): Partial<PaginationBase> => ({
  page: getParamAsInt(searchParams, "page"),
  page_size: getParamAsInt(searchParams, "page_size"),
});
